import { type RefObject, useCallback } from 'react';

/**
 * Hook that returns a click handler for logo that resets the drug interactions state
 * when a reset function is available via ref
 */
export function useResetOnLogoClick(resetRef: RefObject<(() => void) | null>) {
  return useCallback(
    (e: React.MouseEvent) => {
      if (resetRef.current) {
        e.preventDefault();
        resetRef.current();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    [resetRef],
  );
}
